import _objectSpread from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectDestructuringEmpty from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty";
import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import SVGBan from "../assets/svgban.js";
import '../assets/index.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Denied(_ref) {
  var props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(Modal, _objectSpread(_objectSpread({
    show: true
  }, props), {}, {
    className: 'share-component',
    size: "lg",
    centered: true,
    contentClassName: "custom-content",
    children: /*#__PURE__*/_jsx("div", {
      className: "first-level",
      children: /*#__PURE__*/_jsxs("div", {
        className: "first-level-content",
        children: [/*#__PURE__*/_jsx(Modal.Header, {
          children: /*#__PURE__*/_jsxs(Modal.Title, {
            id: "contained-modal-title-vcenter",
            children: [/*#__PURE__*/_jsx("div", {
              className: "header-image",
              children: /*#__PURE__*/_jsx(SVGBan, {
                className: "header-svg"
              })
            }), props.title]
          })
        }), /*#__PURE__*/_jsx(Modal.Body, {
          children: props.description
        }), /*#__PURE__*/_jsx(Modal.Footer, {
          children: /*#__PURE__*/_jsx(Button, {
            onClick: props.onHide,
            variant: "primary",
            children: "Done"
          })
        })]
      })
    })
  }));
}
export { Denied };